import React from "react";
import "./SalesReport.css";
import LoadingOverlay from "../../../../common/LoadingBar.js";
import loader from "../../../../../assets/Image/Loader2.gif";
const SalesReportTable = ({ data, loading }) => {
  const calculateTotals = () => {
    if (!data || !Array.isArray(data) || data.length === 0) {
      return {
        totalProfit: 0,
        totalPayable: 0,
        totalProfitPercentage: 0, 
      };
    }

    const totals = data.reduce(
      (acc, invoice) => {
        acc.totalProfit += invoice.total_profit || 0;
        acc.totalPayable += invoice.payable_amount || 0;
        acc.totalProfitPercentage += invoice.profit_percentage || 0;
        return acc;
      },
      { totalProfit: 0, totalPayable: 0, totalProfitPercentage:0}
    );

    return totals;
  };

  const totals = calculateTotals();

  const downloadCSV = () => {
    // ... keeping your existing downloadCSV function unchanged
  };

  return (
    <div className="data-table-container">
      <table
        className="data-table custom-table"
        style={{
          borderRadius: "20px 20px 20px 20px",
          border: "1px solid #EBEAF2",
          borderCollapse: "separate",
          borderSpacing: 0,
          overflow: "hidden",
        }}
      >
        <thead className="table-header">
          <tr>
            <th>Invoice Number</th>
            <th>Invoice Date</th>
            <th>Customer</th>
            <th style={{ textAlign: "center" }}>Product</th>
            <th>P & L</th>
            <th>Grand Total</th>
            <th>Profit Percentage</th>
          </tr>
        </thead>
        <tbody className="table-body">
        {loading ? (
      <LoadingOverlay loading={loading} loader={loader} />
          ) : data.length === 0 ? (
            <tr>
              <td colSpan="7" style={{ textAlign: "center" }}>
                No data available
              </td>
            </tr>
          ) : (
            data.map((invoice, index) => (
              <tr key={index}>
                <td>{invoice.invoice_number}</td>
                <td>{invoice.invocie_date || "-"}</td>
                <td>{invoice.invoice_customer || "-"}</td>
                <td style={{ textAlign: "center" }}>
                  {Array.isArray(invoice.products)
                    ? invoice.products.join(", ")
                    : invoice.products}
                </td>
                <td style={{ textAlign: "" }}>
                  {invoice.total_profit
                    ? `$${invoice.total_profit.toFixed(2)}`
                    : "-"}
                </td>
                <td style={{ textAlign: "" }}>
                  {invoice.payable_amount
                    ? `$${invoice.payable_amount.toFixed(2)}`
                    : "-"}
                </td>
                <td style={{ textAlign: "" }}>
                  {invoice.profit_percentage
                    ? `${invoice.profit_percentage.toFixed(2)}%`
                    : "-"}
                </td>
              </tr>
            ))
          )}
        </tbody>
        <tfoot className="sales-report-footer">
          <tr>
            <td colSpan="3"></td>
            <td className="grand-total-cell">
              <span className="grand-total-text">Grand Total</span>
            </td>
            <td style={{ textAlign: "", fontWeight: "600" }}>
              ${totals.totalProfit.toFixed(2)}
            </td>
            <td style={{ textAlign: "", fontWeight: "600" }}>
              ${totals.totalPayable.toFixed(2)}
            </td>
            <td style={{ textAlign: "", fontWeight: "600" }}>
              ${totals.totalProfitPercentage.toFixed(2)}
            </td>
            <td></td>
          </tr>
        </tfoot>
      </table>

      <div className="table-actions">
        <button
          onClick={downloadCSV}
          className="sales-report-button"
          disabled={!data || data.length === 0}
        >
          Export CSV
        </button>
      </div>
    </div>
  );
};

export default SalesReportTable;
